import { Amplify } from '@aws-amplify/core';
import awsconfig from './../aws-exports';
import Analytics from '@aws-amplify/analytics';

export const AWSAnalytics = {
  record: async(eventName) => {
    Amplify.configure(awsconfig);
    try {
      return await Analytics.record({ name: eventName });
    } catch (error) {
      return error;
    }
  },
};
